"use client";

import { ImageTransformOptions, contentfulImageLoader } from "@utils/imageLoader";
import React, { ComponentPropsWithoutRef, FC, useEffect, useState } from "react";

interface Props extends Omit<ComponentPropsWithoutRef<"img">, "height" | "width">, ImageTransformOptions {
  src: string;
  alt: string;
  className?: string;
  priority?: boolean;
  fallbackSrc?: string;
}
const Image: FC<Props> = ({ src, width, alt, className, priority, fallbackSrc, onError, ...rest }) => {
  const [imageSrc, setImageSrc] = useState(src);

  useEffect(() => {
    setImageSrc(src);
  }, [src]);

  const handleError: ComponentPropsWithoutRef<"img">["onError"] = (event) => {
    if (fallbackSrc && imageSrc !== fallbackSrc) setImageSrc(fallbackSrc);
    onError?.(event);
  };

  const srcSet = [1, 2].map((dpr: number) => {
    const props = {
      src: imageSrc,
      ...rest,
      width: width * dpr,
      height: rest?.height ? rest?.height * dpr : undefined,
    };
    return `${contentfulImageLoader(props)} ${dpr}x`;
  });
  return (
    <img
      loading={priority ? "eager" : rest?.loading ?? "lazy"}
      fetchPriority={priority ? "high" : undefined}
      decoding={priority ? "auto" : "async"}
      width={width}
      height={rest?.height}
      className={className}
      srcSet={srcSet.join(", ")}
      src={contentfulImageLoader({ src: imageSrc, width })}
      alt={alt}
      onError={handleError}
    />
  );
};
export default Image;
